import React, { FC } from "react";
import { useTranslation } from "i18n";
import { ConfirmationPopup } from "component-library";
import { checkIsAgent } from "shared-auth";
import { HeapCustomEvent } from "shared-services";
import { useTrackSelfTapeHeapEvent } from "shared/hooks/useTrackSelfTapeHeapEvent";

interface Props {
  selfTapeRequestId: string;
  confirmPopUpIsOpen: boolean;
  close: () => void;
  proceed: () => Promise<void>;
}

const ConfirmSendSelfTape: FC<Props> = ({
  selfTapeRequestId,
  confirmPopUpIsOpen,
  close,
  proceed,
}) => {
  const { t } = useTranslation();
  const isAgent = checkIsAgent();
  const trackEvent = useTrackSelfTapeHeapEvent(selfTapeRequestId);

  return confirmPopUpIsOpen ? (
    <ConfirmationPopup
      texts={{
        title: t("common:confirmationPopUp.title.areYouSure"),
        description: isAgent
          ? t("common:mediaRequest.page.confirmation.body.description.agent")
          : t(
              "common:mediaRequest.page.confirmation.body.description.performer"
            ),
        proceed: t("common:mediaRequest.page.confirmation.submit"),
        cancel: t("common:button.label.cancel"),
      }}
      handleProceed={async () => {
        await proceed();
        trackEvent(
          isAgent
            ? HeapCustomEvent.AgentTapeRequestUpload
            : HeapCustomEvent.PerformerTapeRequestUpload
        );
      }}
      handleCancel={close}
    />
  ) : null;
};

export default ConfirmSendSelfTape;
